import { observer } from 'mobx-react-lite'
import { useEffect, useRef } from 'react'
import { type IScrollbarsPropsRef, Scrollbar, SpinnerLoader } from 'shared/ui'
import { useSectionConversationContext } from 'pages/conversations/pages/search/pages/profile/ui/SectionConversation/context/sectionConversationContext'
import { ConversationCard } from 'pages/conversations/pages/search/pages/profile/ui/SectionConversation/ui/ConversationList/ui/ConversationCard/ConversationCard'
import { NotFound } from 'pages/conversations/pages/search/pages/profile/ui/SectionConversation/ui/ConversationList/ui/NotFound/NotFound'
import styles from './styles.module.scss'

export const ConversationList = observer(() => {
  const { init, items, onOpenConversation, currentItemId, setVisibleUI, loading, dispose } =
    useSectionConversationContext()
  const scrollRef = useRef<IScrollbarsPropsRef | null>(null)

  useEffect(() => {
    setVisibleUI(true)
    init()

    return () => {
      setVisibleUI(false)
      dispose()
    }
  }, [])

  useEffect(() => {
    if (!items.length) return
    if (loading) return

    const scroll = scrollRef.current
    const elScroll = scrollRef.current?.container
    const elCard = document.getElementById(`conversation_${currentItemId}`)

    if (scroll && elScroll && elCard) {
      const clientHeightScroll = elScroll.clientHeight
      const clientHeightCard = elCard.clientHeight
      const offsetTopCard = elCard.offsetTop

      scroll.scrollTo({
        top: offsetTopCard - (clientHeightScroll / 2 - clientHeightCard / 2),
      })
    }
  }, [items.length, loading])

  if (loading) {
    return (
      <div className={styles.wrap}>
        <SpinnerLoader ariaLabel={'ConversationList'} />
      </div>
    )
  }

  if (!items.length) {
    return (
      <div className={styles.wrap}>
        <NotFound />
      </div>
    )
  }

  return (
    <div className={styles.wrap}>
      <Scrollbar ref={scrollRef} indentX={9}>
        {items.map((item) => {
          return (
            <ConversationCard
              key={item.id}
              item={item}
              active={item.id === currentItemId}
              onChangeActive={onOpenConversation}
            />
          )
        })}
      </Scrollbar>
    </div>
  )
})
